import { ListStore } from "Stores/RESTStore/ListStore";
import { API_URL } from "General/APIEndpoints";

import { action, computed, makeObservable, observable } from "mobx";
import { projectsDataStore } from "Stores/ProjectsStore";

class LastActionsStore extends ListStore<API_Notification> {
  url() {
    return API_URL.NOTIFICATIONS.getLast_1();
  }
  viewMode: "ALL" | "PROJECT" = "ALL";

  constructor() {
    super();
    makeObservable(this, {
      filteredList: computed,
      setViewMode: action,
      viewMode: observable,
    });
  }
  setViewMode(mode: "ALL" | "PROJECT") {
    if (projectsDataStore.selectedProjectIdOnDashboard === -1 && projectsDataStore?.activeProjectsList?.length) {
      projectsDataStore.selectedProjectIdOnDashboard = projectsDataStore?.activeProjectsList[0].id;
    }
    this.viewMode = mode;
  }

  get filteredList() {
    if (this.viewMode === "ALL" || projectsDataStore.selectedProjectIdOnDashboard === -1) {
      return this.list;
    }
    return this.list.filter((p) => p.projectId === projectsDataStore.selectedProjectIdOnDashboard);
  }
}

export const lastActionsStore = new LastActionsStore();
